export class UISubscriptionOverlayState {
    get membershipToggleYearlyActive() {
        return this._membershipToggleYearlyActive;
    }
    set membershipToggleYearlyActive(yearlyActive) {
        var _this_tabsController;
        this._membershipToggleYearlyActive = yearlyActive;
        for (const membershipView of this.membershipViews){
            const isViewVisible = membershipView.membershipProduct.billedAnnually == yearlyActive;
            membershipView.productDiv.style.display = isViewVisible ? 'flex' : 'none';
        }
        (_this_tabsController = this.tabsController) === null || _this_tabsController === void 0 ? void 0 : _this_tabsController.setTabAnnual(yearlyActive);
    }
    constructor(){
        this.clickAnalyticSource = 'subscription-overlay';
        this.membershipViews = [];
        this._membershipToggleYearlyActive = true;
    }
}
